import { FC, ReactElement } from 'react'

import { ListGroupItem, MaterialIcon, TimeTicker } from '@/components'
import { convertDateToDateString, convertDateToDay, convertDateToTime } from '@/helpers/DateTimeParser'
import { trans } from '@/helpers/trans'
import { TrackResource } from '@/models'

const getTime = (track: TrackResource): ReactElement | string => {
    if (! track.billableEnd) {
        return <TimeTicker from={track.checkIn} />
    }

    return `${convertDateToTime(track.billableStart)} - ${convertDateToTime(track.billableEnd)}`
}

interface TrackListItemProps {
    track: TrackResource
    onClick?: () => void
    className?: string
}

export const TrackListItem: FC<TrackListItemProps> = ({ track, onClick = () => {}, className = '' }): ReactElement => {
    const start = track.billableStart || track.checkIn
    const end = track.billableEnd || track.checkOut

    return (
        <ListGroupItem onClick={onClick} className={className}>
            <div className="list-group-item__header">
                <div className="d-flex flex-row text">
                    <div className="font-weight-bold">{`${convertDateToDay(start)} -`}</div>
                    <div className="text text-nowrap ml-1"> {convertDateToDateString(start)}</div>
                </div>
                <div className={`text ${track.shift ? '' : 'text-danger'}`}>
                    {track.shift ? track.shift.department.name : trans('pages.tracks.unplannedShift')}
                </div>
            </div>
            <div className={`text ${end ? '' : 'text-danger'} align-self-center ml-auto`}>
                {getTime(track)}
            </div>
            <div>
                <MaterialIcon kind="chevron_right" color="secondary" />
            </div>
        </ListGroupItem>
    )
}
